'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryPage = exports.asyncProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _class, _temp; // Country

// if bindActionCreators is needed, uncomment this line
// import {bindActionCreators} from 'redux';
// programmatically pushes a new location to history, uncomment if needed
// import { push } from 'react-router-redux';

// api

// // containers
// import SomeContainer from './SomeContainer';
// // components

// // action creators


exports.mapStateToProps = mapStateToProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _trvFedApiClient = require('../trv-fed-api-client.js');

var _trvFedApiClient2 = _interopRequireDefault(_trvFedApiClient);

var _BreadCrumb = require('../components/BreadCrumb');

var _BreadCrumb2 = _interopRequireDefault(_BreadCrumb);

var _Signature = require('../components/Signature');

var _Signature2 = _interopRequireDefault(_Signature);

var _HotelSearchBox = require('./HotelSearchBox');

var _HotelSearchBox2 = _interopRequireDefault(_HotelSearchBox);

var _PlaceList = require('../components/PlaceList');

var _PlaceList2 = _interopRequireDefault(_PlaceList);

var _Subdivision = require('../components/Subdivision');

var _Subdivision2 = _interopRequireDefault(_Subdivision);

var _breadcrumbs = require('../modules/breadcrumbs');

var _navigations = require('../modules/navigations');

var _signatures = require('../modules/signatures');

var _topDestinations = require('../modules/topDestinations');

var _search = require('../modules/search');

var _exception = require('../modules/exception');

var _query = require('../helpers/query');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/makeomatic/redux-connect/blob/master/docs/API.MD
var asyncProps = exports.asyncProps = [{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        location = _ref.location,
        params = _ref.params;

    var state = getState();
    var promises = [];
    var urls = state.urls,
        breadcrumbs = state.breadcrumbs;

    // TODO: make it stateless and always get breadcrumbs and navigations for now
    //       after refactor the reducers, we should find a better way to prevent fetching breadcrumbs every time

    var ids = (0, _query.getIds)(params);
    if (!breadcrumbs.items.length || breadcrumbs.ids !== ids) {
      var types = ['country', 'subdivision', 'city', 'spot'].slice(0, (0, _keys2.default)(params).length).join(',');
      promises.push((0, _trvFedApiClient2.default)(urls.api.breadcrumbs, 'GET', { ids: ids, types: types, category: 'multilingual' }, state.httpRequest.req, {
        maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
        timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
      }, 3000).then(function (res) {
        return dispatch((0, _breadcrumbs.set)((0, _extends3.default)({ ids: ids }, res)));
      }, function (res) {
        dispatch((0, _breadcrumbs.clear)());
        dispatch((0, _exception.throwException)(res.errors));
      }));
    }

    promises.push((0, _trvFedApiClient2.default)(urls.api.signatures.replace(':countryID', params.countryID), 'GET', {}, state.httpRequest.req, undefined, 3000).then(function (res) {
      return dispatch((0, _signatures.set)(res));
    }, function (res) {
      dispatch((0, _signatures.clear)());
      // Should not throw exception
      // Even if error has been occurred, service should be available
      console.error(res);
    }));

    // TODO: does the navigations API really need the subdivision param?
    promises.push((0, _trvFedApiClient2.default)(urls.api.navigations, 'GET', {
      country: params.countryID
    }, state.httpRequest.req, undefined, 2000).then(function (res) {
      return dispatch((0, _navigations.set)((0, _extends3.default)({ ids: params.countryID }, res)));
    }, function (res) {
      console.error(res);
      dispatch((0, _navigations.clear)());
    }));

    promises.push((0, _trvFedApiClient2.default)(urls.api.topDestinations.replace(':countryID', params.countryID), 'GET', {}, state.httpRequest.req, undefined, 3000).then(function (res) {
      return dispatch((0, _topDestinations.set)(res));
    }, function (res) {
      console.error(res);
      dispatch((0, _topDestinations.clear)());
    }));

    if ((0, _keys2.default)(location.query).length) {
      dispatch((0, _search.update)(location.query));
    } else {
      dispatch((0, _search.clear)());
    }

    return _promise2.default.all(promises);
  }
}];

// mapStateToprops can be either an object or a funciton
function mapStateToProps(state, ownProps) {
  return {
    i18n: state.i18n,
    location: ownProps.location,
    breadcrumbs: state.breadcrumbs.items,
    navigations: state.navigations,
    signatures: state.signatures,
    topDestinations: state.topDestinations
  };
}

// eslint-disable-next-line react/prefer-stateless-function
var CountryPage = exports.CountryPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CountryPage, _Component);

  function CountryPage() {
    (0, _classCallCheck3.default)(this, CountryPage);
    return (0, _possibleConstructorReturn3.default)(this, (CountryPage.__proto__ || (0, _getPrototypeOf2.default)(CountryPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(CountryPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          i18n = _props.i18n,
          location = _props.location,
          breadcrumbs = _props.breadcrumbs,
          navigations = _props.navigations,
          signatures = _props.signatures,
          topDestinations = _props.topDestinations;

      return _react2.default.createElement(
        'div',
        { id: 'content', className: 'area-layout01-wide layout-fluid' },
        _react2.default.createElement(_BreadCrumb2.default, { items: breadcrumbs, location: location }),
        _react2.default.createElement(
          _Signature2.default,
          { i18n: i18n, items: signatures, hideDetails: true },
          _react2.default.createElement(_HotelSearchBox2.default, { hideDetails: true, display: 'form' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'area' },
          topDestinations && topDestinations.length ? _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'heading' },
              _react2.default.createElement(
                'h2',
                { className: 'title' },
                i18n.top.moreToExplore
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'content' },
              topDestinations.map(function (subdivision, index) {
                return _react2.default.createElement(_Subdivision2.default, { key: index, title: subdivision.title, imageUrl: subdivision.imageUrl, pageUrl: subdivision.pageUrl });
              })
            )
          ) : null,
          navigations.subdivisions && navigations.subdivisions.length ? _react2.default.createElement(
            'div',
            { className: 'container featureRecommend featureHotelList' },
            _react2.default.createElement(
              'div',
              { className: 'content' },
              _react2.default.createElement(
                'div',
                { className: 'container00' },
                _react2.default.createElement(
                  'div',
                  { className: 'heading' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title' },
                    i18n.country.searchDestination
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'content' },
                  _react2.default.createElement(_PlaceList2.default, { items: navigations.subdivisions, location: location })
                )
              )
            )
          ) : null
        ),
        _react2.default.createElement(_BreadCrumb2.default, { id: 'subfooter', items: breadcrumbs, location: location })
      );
    }
  }]);
  return CountryPage;
}(_react.Component), _class.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.object.isRequired,
  breadcrumbs: _react.PropTypes.array.isRequired,
  navigations: _react.PropTypes.object.isRequired,
  signatures: _react.PropTypes.array.isRequired,
  topDestinations: _react.PropTypes.array.isRequired
}, _temp);


var asyncConnectedCountry = (0, _reduxConnect.asyncConnect)(asyncProps)(CountryPage);

exports.default = (0, _reactRedux.connect)(mapStateToProps)(asyncConnectedCountry);


//////////////////
// WEBPACK FOOTER
// ./src/containers/CountryPage.js
// module id = 1234
// module chunks = 0